import { IS_DEVELOPMENT } from "../../utils/utilities";

export default function NotFoundPage() {
  const url = IS_DEVELOPMENT
    ? "https://perigigi-dev.web.app"
    : "https://perigigi-dental.com";

  const whatsappUrl =
    "https://wa.me/6287874987379?text=Halo%20Perigigi%2C%20saya%20ingin%20mendaftar%20aplikasi.";

  return (
    <div className="flex h-screen items-center justify-center flex-col text-center px-4 bg-gray-50">
      <h1 className="text-5xl font-extrabold text-red-600 mb-4">404</h1>
      <h2 className="text-2xl font-semibold mb-2">Halaman Tidak Ditemukan</h2>
      <p className="text-gray-600 mb-6">
        Maaf, halaman yang kamu cari tidak tersedia. Kembali ke{" "}
        <a
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          className="text-blue-600 underline hover:text-blue-800"
        >
          Perigigi
        </a>
      </p>
      <p className="text-gray-700 mb-6">
        Ingin daftar aplikasi Perigigi? Klik tombol di bawah ini untuk langsung
        menghubungi kami via WhatsApp:
      </p>
      <a
        href={whatsappUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="inline-block bg-green-500 hover:bg-green-600 text-white font-medium py-2 px-4 rounded-lg shadow transition"
      >
        Hubungi via WhatsApp
      </a>
    </div>
  );
}
